import { supabase } from '@/integrations/supabase/client';

export type ScrapeOptions = {
  formats: ('markdown' | 'html')[];
  onlyMainContent: boolean;
  waitFor?: number;
};

type FirecrawlResponse = {
  success: boolean;
  error?: string;
  data?: {
    markdown?: string;
    html?: string;
    metadata?: {
      title?: string;
      description?: string;
      sourceURL?: string;
    };
  };
};

export const firecrawlApi = {
  async scrape(url: string, options?: Partial<ScrapeOptions>): Promise<FirecrawlResponse> {
    const { data, error } = await supabase.functions.invoke('firecrawl-scrape', {
      body: { url, options },
    });

    if (error) {
      return { success: false, error: error.message };
    }
    
    // Handle Firecrawl response structure (data.data for nested content)
    return {
      success: data?.success ?? true,
      data: data?.data || data,
      error: data?.error,
    };
  },
};
